var _defs, _rect, _path, _circle, _circle2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConstructionSign(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".construction-sign_svg__a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "construction-sign_svg__a",
    x: 0.75,
    y: 5.25,
    width: 22.5,
    height: 10.5,
    rx: 1,
    ry: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "construction-sign_svg__a",
    d: "M3.75 15.75v7.5M20.25 15.75v7.5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "construction-sign_svg__a",
    cx: 6,
    cy: 2.25,
    r: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "construction-sign_svg__a",
    cx: 18,
    cy: 2.25,
    r: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "construction-sign_svg__a",
    d: "M8.25 5.25l-7.5 7.5M14.25 5.25l-10.5 10.5M20.25 5.25l-10.5 10.5M23.25 8.25l-7.5 7.5"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGRlZnM+PHN0eWxlPi5he2ZpbGw6bm9uZTtzdHJva2U6Y3VycmVudENvbG9yO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDtzdHJva2Utd2lkdGg6MS41cHg7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5jb25zdHJ1Y3Rpb24tc2lnbjwvdGl0bGU+PHJlY3QgY2xhc3M9ImEiIHg9IjAuNzUiIHk9IjUuMjUiIHdpZHRoPSIyMi41IiBoZWlnaHQ9IjEwLjUiIHJ4PSIxIiByeT0iMSIvPjxsaW5lIGNsYXNzPSJhIiB4MT0iMy43NSIgeTE9IjE1Ljc1IiB4Mj0iMy43NSIgeTI9IjIzLjI1Ii8+PGxpbmUgY2xhc3M9ImEiIHgxPSIyMC4yNSIgeTE9IjE1Ljc1IiB4Mj0iMjAuMjUiIHkyPSIyMy4yNSIvPjxjaXJjbGUgY2xhc3M9ImEiIGN4PSI2IiBjeT0iMi4yNSIgcj0iMS41Ii8+PGNpcmNsZSBjbGFzcz0iYSIgY3g9IjE4IiBjeT0iMi4yNSIgcj0iMS41Ii8+PGxpbmUgY2xhc3M9ImEiIHgxPSI4LjI1IiB5MT0iNS4yNSIgeDI9IjAuNzUiIHkyPSIxMi43NSIvPjxsaW5lIGNsYXNzPSJhIiB4MT0iMTQuMjUiIHkxPSI1LjI1IiB4Mj0iMy43NSIgeTI9IjE1Ljc1Ii8+PGxpbmUgY2xhc3M9ImEiIHgxPSIyMC4yNSIgeTE9IjUuMjUiIHgyPSI5Ljc1IiB5Mj0iMTUuNzUiLz48bGluZSBjbGFzcz0iYSIgeDE9IjIzLjI1IiB5MT0iOC4yNSIgeDI9IjE1Ljc1IiB5Mj0iMTUuNzUiLz48L3N2Zz4=";
export { SvgConstructionSign as ReactComponent };